module.exports = __webpack_public_path__ + "img/pokenews.4f694b46.png";